// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"573":"458c27263b44c92d","827":"1cb10b88861d09b9","888":"e1c011f057209b26"}[chunkId] + ".css";
};